import { AccordionComponent } from './Accordion.types';
import { Box, Button, Flexbox, Icon, IconDirection } from '@hiiretail/synergy-ui';
import { AccordionBody, AccordionHeader, AccordionWrapper } from './Accordion.style';
import { useState } from 'react';
import styled from 'styled-components';

const AccordionButton = styled(Button)`
  padding: 0;
  &:hover{
    background: inherit;
  }
`

export const Accordion: AccordionComponent = ({
  isExpanded = false,
  children,
  title,
  onToggle,
}) => {
  const [internalOpen, setInternalOpen] = useState(isExpanded);
  const isOpen = onToggle !== undefined ? isExpanded : internalOpen;

  const toggleIsOpen = () => {
    if (onToggle) {
      onToggle(!isExpanded);
    } else {
      setInternalOpen((prev) => !prev);
    }
  };

  return (
    <AccordionWrapper container direction="column">
      <AccordionHeader
        container
        alignItems="center"
        justifyContent="flex-start"
        onClick={() => {
          toggleIsOpen();
        }}
      >
        <Flexbox item container>
          {title}
        </Flexbox>
        <Flexbox item container  justifyContent="flex-end">
          <AccordionButton variant="icon">
            <>
              {isOpen ? (
                <Icon.Chevron size="lg" direction={IconDirection.Up} />
              ) : (
                <Icon.Chevron size="lg" direction={IconDirection.Down} />
              )}
            </>
          </AccordionButton>
        </Flexbox>
      </AccordionHeader>

      {isOpen && (
        <Box my={6}>
          <AccordionBody container>
            {children}
          </AccordionBody>
        </Box>
      )}
    </AccordionWrapper>
  );
};
